import { useState, useEffect } from 'react';
import { OVER_18_KEY } from '@constants';
import { clearFromSessionStorage, loadFromSessionStorage } from '@utils/storage';
import { useData } from './useData';
import { Over18Modal } from '@components/molecules/Over18Modal';

interface useAgeRestrictionParams {
    needsRestriction: boolean;
}

export function useAgeRestriction({ needsRestriction }: useAgeRestrictionParams) {
    const { login, user } = useData();

    const [userAgeAllowed, setUserAgeAllowed] = useState<boolean>(true);
    const [showOver18Popup, setShowOver18Popup] = useState<boolean>(false);

    useEffect(() => {
        if (needsRestriction) {
            const infoIsOver18 = loadFromSessionStorage(OVER_18_KEY);

            if (login !== null) {
                // user is logged in
                if (user?.data?.over18) {
                    setUserAgeAllowed(true);
                } else if (infoIsOver18 === null) {
                    !showOver18Popup && setShowOver18Popup(true);
                } else if (infoIsOver18 === 'false') {
                    setUserAgeAllowed(false);
                }
            } else {
                // user is not logged in
                if (infoIsOver18) {
                    setUserAgeAllowed(infoIsOver18 === 'true');
                } else {
                    !showOver18Popup && setShowOver18Popup(true);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [needsRestriction, user]);

    // if there are updates to logged in user's age
    // clear session data
    useEffect(() => {
        const infoIsOver18 = loadFromSessionStorage(OVER_18_KEY);
        if (
            (user?.data?.over18 === false && infoIsOver18 === 'true') ||
            (user?.data?.over18 === true && infoIsOver18 === 'false')
        ) {
            clearFromSessionStorage(OVER_18_KEY);
        }
    }, [user?.data?.over18]);

    const over18Modal = <Over18Modal show={showOver18Popup} setShow={setShowOver18Popup} setUserAgeAllowed={setUserAgeAllowed} />;

    return { userAgeAllowed, setUserAgeAllowed, over18Modal };
}
